import { QuoteWithPdfFields, ToggleState } from '@monetize/types/app';
import {
  MDivider,
  MFlex,
  MTab,
  MTabList,
  MTabs,
} from '../../../../components/Monetize';
import { PreviewPdfDrawerZoom } from '../../../../components/Monetize/PreviewPdfDrawer/PreviewPdfDrawerZoom';
import { QuoteDownloadMenu } from '../../../../components/Quotes/QuoteDownloadMenu';
import { QuotePDFCustomizationToggle } from './QuotePDFCustomizationToggle';

export const QuotePageCustomerBar = ({
  quote,
  pdfDrawerConfig,
  showDownloadButton,
  showCustomizeButton = true,
  tabs = [],
  currentTabIndex = 0,
  currentTabValue,
  zoom,
  setZoom,
  handleTabChange,
  isExternalView,
  headerHeight = 0,
  containerOffset = 0,
}: {
  quote: QuoteWithPdfFields;
  pdfDrawerConfig: {
    externalPdfDrawer: ToggleState;
    setExternalPdfDrawer: (val: ToggleState) => void;
  };
  showDownloadButton: boolean;
  /** Hidden when every customization setting is hidden for the user's roles. */
  showCustomizeButton?: boolean;
  tabs?: { label: string; value: string }[];
  currentTabIndex?: number;
  currentTabValue?: string;
  zoom: number;
  setZoom: (zoom: number) => void;
  handleTabChange: (newTabIndex: number) => void;
  isExternalView: boolean;
  headerHeight?: number;
  containerOffset?: number;
}) => {
  const topValue =
    isExternalView || containerOffset === undefined
      ? headerHeight
      : Math.max(0, headerHeight - containerOffset + 16);

  return (
    <MFlex
      alignItems="center"
      justifyContent="space-between"
      p={4}
      position="sticky"
      top={`${topValue}px`}
      zIndex={3}
      backgroundColor="white"
    >
      <>
        {!!tabs?.length && (
          <MTabs
            variant="centered"
            size="sm"
            mb={0}
            index={currentTabIndex}
            onChange={handleTabChange}
          >
            <MTabList>
              {tabs.map(({ label, value }) => (
                <MTab key={value} mr={2}>
                  {label}
                </MTab>
              ))}
            </MTabList>
          </MTabs>
        )}
        <MFlex justifyContent="end" alignItems="center">
          {currentTabValue !== 'QUOTE' && (
            <>
              <MFlex pr={2}>
                <PreviewPdfDrawerZoom zoom={zoom} onChange={setZoom} />
              </MFlex>
              <MDivider
                orientation="vertical"
                variant={'solid'}
                background={'tBlack.200'}
                w="1px"
                h="24px"
                mx={1}
              ></MDivider>
            </>
          )}

          {showDownloadButton && (
            <>
              <QuoteDownloadMenu quote={quote} />
              {currentTabValue === 'QUOTE' && (
                <MDivider
                  orientation="vertical"
                  variant={'solid'}
                  background={'tBlack.200'}
                  w="1px"
                  h="24px"
                  mx={1}
                ></MDivider>
              )}
            </>
          )}
          {currentTabValue === 'QUOTE' && showCustomizeButton && (
            <QuotePDFCustomizationToggle
              state={pdfDrawerConfig.externalPdfDrawer}
              onClick={pdfDrawerConfig.setExternalPdfDrawer}
            />
          )}
        </MFlex>
      </>
    </MFlex>
  );
};
